import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=29585a05"
import script from "./ToTopButton.vue?vue&type=script&lang=js"
export * from "./ToTopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowUpIcon: require('/vercel/path0/components/icons/ArrowUpIcon.vue').default,Container: require('/vercel/path0/components/shared/Container.vue').default})
